<template>
  <WorkGenericPicker
    v-model="inputVal"
    :vid="vid"
    :label="customLabel"
    :path="customPath ? customPath : 'projects'"
    :item-text="
      customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :sort-by="internalSortBy"
    :api-get-response-item-text="
      customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :headers="internalHeaders"
    v-bind="$props"
    v-on="$listeners"
  >
    <template #header>
      {{ `${customLabel} ${$t('Common.choose')}` }}
    </template>
    <template #tooltip>
      {{ `${customLabel} ${$t('Common.choose')}` }}
    </template>

    <template #filters>
      <slot name="filters">
        <w-row>
          <w-column cols="auto">
            <w-multiple-selection-filter-lazy
              :label="$t('Projects.words.customerContact')"
              path="projects/contacts"
              item-text="companyName"
              item-value="id"
              searchKey="customers"
              clearable
            />
          </w-column>
          <w-column cols="auto">
            <w-multiple-selection-filter-lazy
              :label="$t('Common.participant')"
              path="projects/participants"
              item-text="name"
              item-value="id"
              searchKey="participants"
              clearable
            />
          </w-column>
          <w-column cols="auto">
            <w-multiple-selection-filter-lazy
              :label="$t('Common.projectManager')"
              path="projects/projectmanagers"
              item-text="fullname"
              item-value="id"
              searchKey="managers"
              clearable
            />
          </w-column>
          <w-column cols="auto">
            <w-autocomplete-lazy
              :label="$t('Common.projectType')"
              path="projects/customtypes"
              :get-data="response => response.data.data"
              item-text="data.label"
              item-value="id"
              searchKey="customtypeid"
              clearable
            />
          </w-column>
        </w-row>
      </slot>
    </template>
    <template #item="{ item }">
      {{ defaultItemText(item) }}
    </template>
  </WorkGenericPicker>
</template>
<script>
// mixins
import genericPickerProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-props';
import genericPickerDialogProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-dialog-props';
// components
import WorkGenericPicker from '@/components/global_components/pickers/generic_picker/WorkGenericPicker';
//helpers
import i18n from '@/language/i18n';

const DEFAULT_HEADERS = [
  { text: i18n.t('Common.matchcode'), value: 'matchcode' },
  { text: i18n.t('Common.label'), value: 'label' },
  { text: i18n.t('Common.projectManager'), value: 'projectManager' },
  { text: i18n.t('Common.customer'), value: 'customer' },
  { text: i18n.t('Common.participant'), value: 'participants' },
  { text: i18n.t('Components.sentences.assignedEmployee'), value: 'currentStepEmployee' }
];

export default {
  name: 'WorkProjectPicker',
  components: {
    WorkGenericPicker
  },
  mixins: [genericPickerProps, genericPickerDialogProps],
  props: {
    customPath: { type: String },
    customItemText: { type: String },
    customLabel: { type: String, default: i18n.t('Common.project') },
    customSort: { type: Function }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    internalHeaders() {
      if (this.headers) {
        return this.headers;
      }
      return DEFAULT_HEADERS;
    },
    internalSortBy() {
      if (this.sortBy != undefined) 
        return this.sortBy;

      if (this.customItemText != undefined)
        return [this.customItemText.split('.')?.pop()];

      return ['matchcode', 'label'];
    }
  },
  methods: {
    defaultItemText(item) {
      return `${item?.data?.matchcode ?? item.data?.projectMatchCode ?? item.matchcode} - ${item?.data?.label ?? item.label}`;
    },
  }
};
</script>
